<template>
  <div>
    <v-container class="col-12 ml-0 mt-4 pl-0 pb-7 pt-0">
      <v-row :style="searchHeight" class="mb-4 ml-0" cols="12">
        <v-col :style="searchHeight" class="col-2 pb-0 pt-6 pl-0"
          >상품 등록일</v-col
        >

        <v-col class="col-4">
          <v-menu
            v-model="createProductStart"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                outlined
                v-model="searchPayload.from"
                readonly
                v-on="on"
                dense
                :style="textFileSize"
                class="d-inline-block mr-1"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="searchPayload.from"
              @input="startMenu = false"
              locale="ko"
              :max="searchPayload.to"
            ></v-date-picker> </v-menu
          >~
          <v-menu
            v-model="createProductEnd"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                outlined
                v-model="searchPayload.to"
                readonly
                v-on="on"
                dense
                :style="textFileSize"
                class="d-inline-block mr-1"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="searchPayload.to"
              @input="endMenu = false"
              locale="ko"
              :min="searchPayload.from"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col :style="searchHeight" class="col-2 pb-0 pt-6 pl-0">상품명</v-col>
        <v-col class="col-4 pt-3" height="50px">
          <v-text-field
            v-model="searchPayload.product_name"
            outlined
            dense
            placeholder="상품명 입력"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row :style="searchHeight" class="mb-4 ml-0" cols="12">
        <v-col cols="2" class="pl-0 pt-6">인증코드 생성여부</v-col>
        <v-col cols="4">
          <v-select
            v-model="searchPayload.created_auth_code"
            :items="authCodeCreateState"
            label="Select"
            persistent-hint
            single-line
            class="pt-0"
            outlined
            dense
            :style="{ width: '86%' }"
          ></v-select>
        </v-col>
        <v-col class="col-2 pl-0">
          <v-select
            v-model="searchPayload.search_type"
            :items="codeItems"
            label="Select"
            persistent-hint
            single-line
            class="pt-0"
            outlined
            dense
            @change="changeSearchType"
          ></v-select>
        </v-col>
        <v-col class="col-4">
          <v-text-field
            outlined
            dense
            :placeholder="searchValuePlaceholder"
            v-model="searchPayload.search_text"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row class="pb-5 pt-4 mt-0">
        <div class="row justify-center mt-2 mb-10">
          <v-btn
            large
            color="grey darken-4"
            class="white--text"
            width="100"
            @click="productSearch()"
            >조회</v-btn
          >
          <v-btn
            large
            style="margin-left: 20px;"
            width="100"
            @click.prevent="resetSearch"
            >초기화</v-btn
          >
        </div>
      </v-row>

      <v-card class="manageCodeList mt-7 mb-4 pb-0">
        <v-col class="mt-0 mb-0">
          <v-btn
            small
            color="grey darken-4"
            class="white--text"
            width="60"
            @click="deleteList()"
            >삭제</v-btn
          >
          <v-btn
            small
            color="green"
            class="white--text"
            width="100"
            style="float:right;"
            @click="excelDownload()"
            >엑셀다운로드</v-btn
          >
        </v-col>
        <v-data-table
          v-model="selectedProduct"
          :headers="headers"
          :items="productInfos"
          calculate-widths
          show-select
          :footer-props="{
            'items-per-page-options': [10, 20, 30, 40, 50],
            'items-per-page-text': '목록 노출 수 선택:',
          }"
          item-key="number"
          scrollable
        >
          <template v-slot:item.number="{ item }">
            <p class="mb-0 mt-3 text-center caption">{{ item.number }}</p>
          </template>

          <template v-slot:item.created="{ item }">
            <p class="mb-0 mt-3 text-left text-truncate caption">
              {{ item.created }}
            </p>
          </template>

          <template v-slot:item.image="{ item }" class="pl-0 pr-0 ml-0 mr-0">
            <v-row no-gutters>
              <v-col>
                <v-img
                  v-if="item.imageurl"
                  :src="item.imageurl"
                  width="60px"
                  height="60px"
                ></v-img>
                <v-img
                  v-else
                  :src="adminDefaultImg"
                  width="60px"
                  height="60px"
                ></v-img>
              </v-col>
            </v-row>
          </template>

          <template
            v-slot:item.productInfo="{ item }"
            class="pl-0 pr-0 ml-0 mr-0"
          >
            <v-row no-gutters>
              <v-col
                :cols="12"
                class="pl-0 pr-0 ml-0 mr-0"
                style="width:170px;overflow: hidden; text-overflow: ellipsis; ; white-space: nowrap; cursor:pointer;"
                @click="productInfoEdit(item)"
              >
                <p
                  class="mb-0 mt-3 mr-0 text-left text-truncate caption"
                  style="text-decoration:underline;"
                >
                  {{ item.product_name }}
                </p>
                <p
                  class="mb-0 mr-0 text-left text-truncate caption"
                  style="text-decoration:underline;"
                >
                  옵션 : {{ item.variant_name }}
                </p>
                <p class="mb-0 mr-0 text-left text-truncate caption">
                  상품코드 : {{ item.product_code }}
                </p>
                <p class="mb-3 mr-0 text-left text-truncate caption">
                  품목코드 : {{ item.variant_code }}
                </p>
              </v-col>
            </v-row>
          </template>

          <template v-slot:item.supplier="{ item }" class="pl-0 pr-0">
            <p class="mb-0 text-truncate caption">{{ item.supplier }}</p>
          </template>

          <template v-slot:item.manufacturer="{ item }" class="pl-0 pr-0">
            <p class="mb-0 text-truncate caption">{{ item.manufacturer }}</p>
          </template>

          <template v-slot:item.brand="{ item }" class="pl-0 pr-0">
            <p class="mb-0 text-center caption">{{ item.brand }}</p>
          </template>

          <template v-slot:item.sellPrice="{ item }" class="pl-0 pr-0">
            <p class="mb-0 text-center caption">{{ item.sellPrice }}</p>
          </template>

          <template v-slot:item.authCodeCreated="{ item }" class="pl-0 pr-0">
            <p class="mb-0 text-center caption">{{ item.authCodeCreated }}</p>
          </template>
          <template slot="no-data">
            <div class="noDataProductInfos">내역이 없습니다.</div>
          </template>
        </v-data-table>
      </v-card>
    </v-container>

    <!-- modal -->
    <v-row justify="center">
      <v-dialog v-model="productInfoEditModal" max-width="1100px">
        <v-card>
          <v-card-title>상품 정보 수정</v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pb-0">
            <v-row class="mt-7">
              <v-col class="col-2 pt-0">
                <p
                  class="font-weight-bold mb-0 body-1 black--text"
                  style="height: 40px ;display: table-cell; vertical-align: middle;"
                >
                  상품명
                </p>
              </v-col>
              <v-col class="pt-0">
                <v-text-field
                  outlined
                  dense
                  hide-details="true"
                  v-model="productName"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="col-2">
                <p
                  class="font-weight-bold mb-0 body-1 black--text"
                  style="height: 40px ;display: table-cell; vertical-align: middle;"
                >
                  상품코드
                </p>
              </v-col>
              <v-col>
                <v-text-field
                  outlined
                  dense
                  hide-details="true"
                  v-model="productCode"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="col-2">
                <p
                  class="font-weight-bold mb-0 body-1 black--text"
                  style="height: 40px ;display: table-cell; vertical-align: middle;"
                >
                  판매가
                </p>
              </v-col>
              <v-col>
                <v-text-field
                  outlined
                  dense
                  hide-details="true"
                  v-model="sellPrice"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="col-2">
                <p
                  class="font-weight-bold mb-0 body-1 black--text"
                  style="height: 40px ;display: table-cell; vertical-align: middle;"
                >
                  공급사명
                </p>
              </v-col>
              <v-col>
                <v-text-field
                  outlined
                  dense
                  hide-details="true"
                  v-model="supplyName"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="col-2">
                <p
                  class="font-weight-bold mb-0 body-1 black--text"
                  style="height: 40px ;display: table-cell; vertical-align: middle;"
                >
                  제조사명
                </p>
              </v-col>
              <v-col>
                <v-text-field
                  outlined
                  dense
                  hide-details="true"
                  v-model="manufacturerName"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="col-2">
                <p
                  class="font-weight-bold mb-0 body-1 black--text"
                  style="height: 40px ;display: table-cell; vertical-align: middle;"
                >
                  브랜드명
                </p>
              </v-col>
              <v-col>
                <v-text-field
                  outlined
                  dense
                  hide-details="true"
                  v-model="brandName"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col class="col-2 pt-1">
                <p
                  class="font-weight-bold body-1 black--text"
                  style="height: 40px ;display: table-cell; vertical-align: middle;"
                >
                  상품이미지
                </p>
              </v-col>
              <v-col class="pb-0 pt-0 pl-1">
                <v-file-input
                  chips
                  label="클릭하여 이미지를 업로드해주세요."
                  class="pt-1 pl-1"
                  accept="image/x-png, image/gif, image/jpeg"
                  hide-details
                  v-model="file"
                ></v-file-input>
              </v-col>
            </v-row>
            <v-row class="mb-6" style="height:40px;">
              <v-col class="col-2 pb-0">
                <p
                  class="font-weight-bold mb-0 body-1 black--text"
                  style="height: 40px ;display: table-cell; vertical-align: middle;"
                >
                  옵션
                </p>
              </v-col>
              <v-col class="col-3 pb-0" style="height:40px;">
                <v-select
                  v-model="optionItemSelect"
                  :items="optionSelectItem"
                  outlined
                  dense
                  single-line
                  item-text="text"
                  item-value="value"
                  @change="optionStateChange()"
                ></v-select>
              </v-col>
              <v-col class="col-5 pb-0" style="height:40px;">
                <v-text-field
                  outlined
                  dense
                  hide-details="true"
                  v-model="optionName"
                  :disabled="optionNameDisabled"
                  :label="optionLabel"
                  single-line
                ></v-text-field>
              </v-col>

              <v-col class="pl-0 pb-0" style="height:40px;">
                <v-btn
                  color="grey darken-4 white--text"
                  large
                  @click="addOption"
                  :disabled="optionNameDisabled"
                  style="width:100%;  height:40px;"
                  >추가</v-btn
                >
              </v-col>
            </v-row>
            <v-row
              v-for="(item, index) in addOptionList"
              v-bind:key="index"
              style="height:40px;"
              class="mt-3"
            >
              <v-col class="col-2"></v-col>
              <v-col class="col-3">{{ item.variant_name }}</v-col>
              <v-col class="col-2">
                <v-text-field
                  outlined
                  dense
                  hide-details="true"
                  :value="item.variant_price"
                  v-model="item.variant_price"
                  placeholder="옵션 판매가 입력"
                ></v-text-field>
              </v-col>
              <v-col class="col-3 pl-0">
                <v-text-field
                  outlined
                  dense
                  hide-details="true"
                  :value="item.variant_code"
                  v-model="item.variant_code"
                  placeholder="품목코드 입력"
                ></v-text-field>
              </v-col>
              <v-col class="pl-0">
                <v-btn
                  color="grey lighten-1"
                  large
                  @click="deleteOption(index)"
                  dense
                  style="width:100%; height:40px;"
                  >삭제</v-btn
                >
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider class="mt-10"></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="productInfoEditModal = false"
              >닫기</v-btn
            >
            <v-btn color="blue darken-1" text @click="productInfoEditSave()"
              >저장</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";
import Excel from "@/libs/excel.js";

export default {
  data() {
    return {
      productInfoEditModal: false,
      optionItemSelect: { text: "없음", value: "X" },
      optionSelectItem: [
        { text: "있음", value: "O" },
        { text: "없음", value: "X" },
      ],
      textFileSize: {
        height: "50px",
        width: "110px",
      },
      searchHeight: {
        height: "50px",
      },
      authCodeCreateState: [
        { text: "전체", value: "A" },
        { text: "있음", value: "Y" },
        { text: "없음", value: "N" },
      ],
      codeSelected: { state: "상품코드" },
      codeItems: [
        { text: "상품코드", value: "product_code" },
        { text: "품목코드", value: "variant_code" },
        { text: "공급사", value: "supplier" },
        { text: "제조사", value: "manufacturer" },
        { text: "브랜드", value: "brand" },
      ],
      startDate: new Date().toISOString().substr(0, 10),
      endDate: new Date().toISOString().substr(0, 10),
      createProductStart: false,
      createProductEnd: false,
      searchValuePlaceholder: "상품코드 입력",
      searchPayload: {
        product_name: "",
        created_auth_code: "A",
        search_type: "product_code",
        search_text: "",
        from: "",
        to: "",
      },
      headers: [
        {
          text: "번호",
          align: "center",
          sortable: false,
          value: "number",
          width: 100,
        },
        {
          text: "등록일시",
          align: "center",
          sortable: false,
          value: "created",
          width: 110,
        },
        {
          text: "이미지",
          align: "center",
          value: "image",
          sortable: false,
          width: 70,
        },
        {
          text: "품목 정보",
          align: "center",
          value: "productInfo",
          sortable: false,
        },
        {
          text: "공급사",
          align: "center",
          value: "supplier",
          sortable: false,
          width: 120,
        },
        {
          text: "제조사",
          align: "center",
          value: "manufacturer",
          sortable: false,
          width: 90,
        },
        {
          text: "브랜드",
          align: "center",
          value: "brand",
          sortable: false,
          width: 100,
        },
        {
          text: "판매가",
          align: "center",
          value: "sellPrice",
          sortable: false,
          width: 100,
        },
        {
          text: "인증코드 생성",
          value: "authCodeCreated",
          sortable: false,
          width: 110,
        },
      ],
      selectedProduct: [],
      productInfos: [
        /*
        {
          number: 1,
          created: "2020.04.05 13:22:22",
          supplier: "소니",
          manufacturer: "-",
          brand: "나이키",
          sellPrice: 28000,
          authCodeCreated: 3,
          product_name: "SONY NIKE 레더 포뮬라 월렛",
          variant_name: "색상 노랑",
          product_code: "P0000MW",
          variant_code: "P00000NW000A",
          variant_price: 30000
        },
        */
      ],
      productInfosCount: 1,
      adminDefaultImg: require("../../../assets/authservice/images/admin_default.png"),
      el: "#example-2",
      addOptionList: [],
      optionName: "",
      productName: "",
      productCode: "",
      sellPrice: "",
      supplyName: "",
      manufacturerName: "",
      brandName: "",
      optionLabel: "",
      optionNameDisabled: true,
      file: [],
      excelData: {
        Excel: null,
        totalLimit: 200000,
        limit: 10000,
        totalCount: 0,
        offset: 0,
        sheetData: [],
        sheetHeader: {
          product_code: "상품코드",
          sellPrice: "판매가",
          supplier: "공급사명",
          manufacturer: "제조사명",
          brand: "브랜드명",
          imageurl: "상품이미지url",
          variant_name: "옵션명",
          variant_price: "옵션판매가",
          variant_code: "품목코드입력",
        },
      },
    };
  },
  mixins: [CommonMixin],
  methods: {
    deleteList: function() {
      let selectProductCount = this.selectedProduct.length;
      for (let i = 0; i < selectProductCount; i++) {
        const index = this.productInfos.indexOf(this.selectedProduct[i]);
        this.productInfos.splice(index, 1);
      }
    },
    productInfoEdit: function(v) {
      this.productName = v.product_name;
      this.productCode = v.product_code;
      this.sellPrice = v.sellPrice;
      this.supplyName = v.supplier;
      this.manufacturerName = v.manufacturer;
      this.brandName = v.brand;
      this.productInfoEditModal = true;
    },
    addOption: function() {
      if (!this.optionName) {
        this.alertShow("옵션명을 입력해주세요.");
        return false;
      }
      let addOptionArray = {
        variant_price: "",
        variant_code: "",
        variant_name: this.optionName,
      };
      this.addOptionList.push(addOptionArray);
      this.optionName = "";
    },
    deleteOption: function(v) {
      this.addOptionList.splice(v, 1);
    },
    optionStateChange: function() {
      if (this.optionItemSelect != "X") {
        this.optionNameDisabled = false;
        this.optionLabel = "옵션명 입력";
      } else {
        this.optionNameDisabled = true;
        this.optionLabel = "";
        this.addOptionList = [];
      }
    },
    /**
     * 검색
     */
    resetSearch: function() {
      this.searchPayload = {
        product_name: "",
        search_type: "product_code",
        search_value: "",
        from: "",
        to: "",
        created_auth_code: "A",
      };
      let befor1Month = new Date();
      befor1Month.setMonth(befor1Month.getMonth() - 1);

      let toDay = new Date();
      this.searchPayload.from = M.yyyymmdd(befor1Month);
      this.searchPayload.to = M.yyyymmdd(toDay);
    },
    /**
     * 검색어 타입 수정
     **/
    changeSearchType: function() {
      let placeholderData = {
        product_code: "상품코드 입력",
        variant_code: "품목코드 입력",
        supplier: "공급사명 입력",
        manufacturer: "제조사명 입력",
        brand: "브랜드명 입력",
      };
      this.searchValuePlaceholder =
        placeholderData[this.searchPayload.search_type];
    },
    productSearch: async function() {
      this.productInfos = [];

      this.defaultProgressShow();

      try {
        let result = await M.api(
          M.entry("/api/cert/partners/products/search"),
          this.searchPayload
        );
        if (result) {
          for (let i = 0; i < result.length; i++) {
            let sellPrice = result[i].product_price;
            if (result[i].variant_price > 0) {
              sellPrice = result[i].variant_price;
            }

            let addData = {
              number: i + 1,
              created: result[i].created_at,
              supplier: result[i].vendor_name,
              manufacturer: result[i].manufacturer_name,
              brand: result[i].brand_name,
              sellPrice: sellPrice,
              authCodeCreated: result[i].quantity,
              product_name: result[i].product_name,
              variant_name: result[i].variant_name,
              product_code: result[i].product_code,
              variant_code: result[i].variant_code,
              imageurl: result[i].list_image,
            };

            this.productInfos.push(addData);
          }
          this.defaultProgressHide();
        }
      } catch (e) {
        //console.log(e);
      }
    },
    productInfoEditSave: async function() {
      /**
       * 데이터 체크 필요
       * 옵션 빈값 체크 필요
       */
      if (
        !this.productName ||
        !this.sellPrice ||
        !this.supplyName ||
        !this.manufacturerName ||
        !this.brandName ||
        !this.productCode
      ) {
        this.alertShow("모든 정보를 입력해 주세요.");
        return false;
      }
      let addData = {
        imageurl: "",
        product_name: this.productName,
        product_price: this.sellPrice,
        supplier: this.supplyName,
        manufacturer: this.manufacturerName,
        brand: this.brandName,
        variant_list: this.addOptionList,
        product_code: this.productCode,
      };

      //옵션 빈값 체크
      for (let i = 0; i < this.addOptionList.length; i++) {
        if (
          !this.addOptionList[i].variant_code ||
          !this.addOptionList[i].variant_price ||
          !this.addOptionList[i].variant_name
        ) {
          this.alertShow("옵션의 정보를 확인 해주세요.");
          return false;
        }
      }

      /**
       * 이미지 등록
       */
      if (this.file.name) {
        let imageResult = await this.imageUpload();
        if (imageResult.state == "200" && imageResult.imageurl) {
          addData.imageurl = imageResult.imageurl;
        }
      }

      try {
        let result = await M.api(
          M.entry("/api/cert/partners/products/code", this.productCode),
          addData
        );

        if (result.product_no > 0) {
          this.alertShow("저장 되었습니다.");
        } else {
          this.alertShow("저장이 되지 않았습니다.");
        }
      } catch (e) {
        this.alertShow("저장이 되지 않았습니다.");
      }
    },
    imageUpload: async function() {
      if (!this.file) {
        this.alertShow("이미지 파일이 없습니다.");
        return false;
      }
      let formData = new FormData();
      formData.append("images", this.file, this.file.name);

      try {
        let data = await M.api(
          M.entry("/api/cert/partners/products/images/code", this.productCode),
          formData
        );
        if (data) {
          //
          return data;
        }
      } catch (e) {
        //
      }
    },
    excelDownload: function() {
      /**
       * 엑셀 파일 다운 전 초기화
       */
      this.excelData.Excel = null;
      this.excelData.totalLimit = 60000;
      this.excelData.limit = 500;
      this.excelData.totalCount = 0;
      this.excelData.offset = 0;
      this.excelData.sheetData = [];
      this.initExcelDownload();
    },

    /**
     * 엑셀 시작
     */
    initExcelDownload: async function() {
      if (this.selectedProduct.length > 0) {
        let progressText = "엑셀 다운로드중입니다.</br>잠시만 기다려 주세요.";
        this.circularProgressShow(progressText);
        this.excelData.Excel = new Excel(null, this.excelData.sheetHeader);
        this.excelData.sheetData = this.selectedProduct;
        await this.addExcel();
      } else {
        this.alertShow("선택된 상품 정보가 없습니다.");
        return false;
      }
    },
    /**
     * 엑셀 추가 데이터
     */
    getExcelDataAdd: async function() {
      this.excelData.offset = this.excelData.offset + this.excelData.limit;
      this.circularProgressSetValue(
        Math.round((this.excelData.offset / this.excelData.totalCount) * 100)
      );

      if (this.excelData.offset > this.excelData.totalCount) {
        await this.endExcel();
        return false;
      }
    },
    /**
     * 시트에 엑셀 추가
     */
    addExcel: async function() {
      if (this.excelData.offset === 0) {
        await this.excelData.Excel.initSheet();
        await this.excelData.Excel.addSheet(this.excelData.sheetData);
        await this.getExcelDataAdd();
      } else {
        await this.getExcelDataAdd();
      }
    },
    /**
     * 파일 다운
     */
    endExcel: async function() {
      setTimeout(() => {
        this.circularProgressHide();
      }, 1500);
      // this.defaultProgressHide();
      let toDay = new Date();
      let year = toDay.getFullYear();
      let month = 1 + toDay.getMonth();
      month = month >= 10 ? month : "0" + month;
      let day = toDay.getDate();
      day = day >= 10 ? day : "0" + day;
      await this.excelData.Excel.endSheet(
        `${year}${month}${day}_${this.$store.state.mallId}`
      );
    },
  },
  mounted: function() {
    let befor1Month = new Date();
    befor1Month.setMonth(befor1Month.getMonth() - 1);
    let toDay = new Date();
    /**
     * 정품인증 코드 생성 -> 확인하러가기 createAuth 파라메터
     */
    if (this.$route.query.createAuth && this.$route.query.createAuth == "Y") {
      this.searchPayload.from = M.yyyymmdd(toDay);
      this.searchPayload.cert_status = "inactivated";
    } else {
      this.searchPayload.from = M.yyyymmdd(befor1Month);
    }
    this.searchPayload.to = M.yyyymmdd(toDay);
  },
};
</script>
